import React, { useEffect, useState } from 'react';
import emailjs from 'emailjs-com';

const Countdown = () => {
  
  const [isOpen, setIsOpen] = useState(false);
  
  // Function to open the pop-up
  const openPopup = () => {
    setIsOpen(true);
  };
  
  // Function to close the pop-up
  const closePopup = () => {
    setIsOpen(false);
  };

// **********************

const Result = () => {
  return <p className="success-message fw-bold text-success">Your Message has been successfully sent. We will contact you soon.</p>;
};
 const [result, showresult] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    phone: ''
  });

  const validate = (name, value) => {
    let errors = { ...formErrors };

    switch (name) {
      case 'fullname':
        errors.fullname = !/^[A-Za-z][A-Za-z\s\-]{3,}$/.test(value) ? 'Full Name must be alphabet and at least 3 characters' : '';
        break;
      case 'email':
        errors.email = !/^\S+@\S+\.\S+$/.test(value) ? 'Invalid email address' : '';
        break;
      case 'phone':
        errors.phone = !/^\d{10}$/.test(value) ? 'Phone number must be 10 digits' : '';
        break;
      default:
        break;
    }

    setFormErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleKeyUp = (e) => {
    const { name, value } = e.target;
    validate(name, value);
  };

  const isValid = () => {
    return !Object.values(formErrors).some(error => error) &&
           formData.fullname && formData.email && formData.phone;
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (!isValid()) {
      alert("Please fix the errors before submitting.");
      return;
    }

    emailjs
      .sendForm('service_kx087j8', 'template_bc3rkxq', e.target, 'EXJNlr7x6Cz38-Sqt')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });

    e.target.reset();
    showresult(true);
    setTimeout(() => showresult(false), 5000);
    setFormData({ fullname: '', email: '', phone: '', subject: '', message: '' });
    setFormErrors({});
  };



// ****************

  const calculateTimeLeft = () => {
    const difference = +new Date('2025-05-01') - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        Days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        Hrs: Math.floor((difference / (1000 * 60 * 60)) % 24),
        Min: Math.floor((difference / 1000 / 60) % 60),
        Sec: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="maintaince">
      <div className="featurearea__countdown countdown-box">
        {Object.entries(timeLeft).map(([label, value]) => (
          <div className="count" key={label}>
            <p>{value.toString().padStart(2, '0')}</p><span>{label}</span>
          </div>
        ))}
        <p>
        Trading in the zone online course<br />
          in just <strong>₹15,000</strong> &nbsp; <s>₹25,000</s>
        </p> &nbsp; &nbsp;

    <a onClick={openPopup} style={{cursor: 'pointer',borderRadius:'50px',padding:'10px 20px'}} className='free-demo-btn '>Enroll Now</a>

      </div>
 


   {/* Pop-up Form */}
   <div className={`popup-form ${isOpen ? 'open' : ''}`}>
        <div className="popup-content">
          <div className="popup-header">
            <h2>Free Demo</h2>
            <button className="close-btn" onClick={closePopup}> x </button>
          </div>
          <form onSubmit={sendEmail}>
            {/* <label for="fullName">Full Name</label> */}
            <input type="text" id="fullName" name="fullname" required placeholder='Enter Your Name' 
            onKeyUp={handleKeyUp}
            onChange={handleChange} className='text-black'
            />
  {formErrors.fullname && <small style={{ color: 'red' }}>{formErrors.fullname}</small>}
            {/* <label for="email">Email</label> */}
            <input type="email" id="email" name="email" required placeholder='Enter Your Email ID'
              onKeyUp={handleKeyUp}
              onChange={handleChange}  className='text-black'/>
              {formErrors.email && <small style={{ color: 'red' }}>{formErrors.email}</small>}

            {/* <label for="phone">Phone Number</label> */}
            <input type="tel" id="phone" name="phone" required placeholder='Enter Your Mobile Number' 
              onKeyUp={handleKeyUp}
              onChange={handleChange} className='text-black'/>
               {formErrors.phone && <small style={{ color: 'red' }}>{formErrors.phone}</small>}

            {/* <label for="referal-code">Referal code</label> */}
            <input type="text" id="referal-code" name="referal-code" placeholder='Referal Code (optional)' 
             className='text-black'/>
            

            <button type="submit" className='mt-2'>Submit</button>
          </form>
          <div className="form-group">
                  {result ? <Result /> : null}
                </div>

        </div>
      </div>

{/* **************************** */}


</div>

  );
};

export default Countdown;

